import { WppTypography } from '@platform-ui-kit/components-library-react'

import styles from 'pages/termsOfService/TermsOfService.module.scss'

export const TermsOfService = () => (
  <div className={styles.container}>
    <WppTypography type="xl-heading">Terms of Service</WppTypography>
  </div>
)
